export enum ContactType {
  Person = 'person',
  Company = 'company',
}
